import React, { useEffect, useState } from "react";
import { D, st, apiGet, apiPost, apiPut } from "../../constants";
import LedJobEstimate from "./LedJobEstimate";
import LoadSchedule from "./LoadSchedule";
import ZonesScenes from "./ZonesScenes";
import AVPlanner from "./AVPlanner";

const TABS = [
  { id: "led", label: "LED Control" },
  { id: "load-schedule", label: "Load Schedule" },
  { id: "zones-scenes", label: "Zones & Scenes" },
  { id: "av-planner", label: "AV Planner" },
];

export default function AVLightingHub(props) {
  const [tab, setTab] = useState("led");
  const [projects, setProjects] = useState([]);
  const [currentProject, setCurrentProject] = useState(null);
  const [pendingData, setPendingData] = useState({});
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    apiGet("/data/av-lighting-projects")
      .then((rows) => setProjects(rows || []))
      .catch(() => {});
  }, []);

  const createProject = async () => {
    const name = window.prompt("Project name (e.g. residence name)?");
    if (!name) return;
    try {
      const res = await apiPost("/data/av-lighting-projects", { name, data: {} });
      const created = { id: res.id, name, address: "", data: {} };
      setProjects((prev) => [created, ...prev]);
      setCurrentProject(created);
      setPendingData({});
      setMessage(null);
    } catch (e) {
      setMessage({ ok: false, text: "Error creating project: " + e.message });
    }
  };

  const selectProject = (value) => {
    if (!value) {
      setCurrentProject(null);
      setPendingData({});
      return;
    }
    const p = projects.find((p) => String(p.id) === String(value));
    setCurrentProject(p || null);
    setPendingData(p?.data || {});
    setMessage(null);
  };

  const saveProject = async () => {
    if (!currentProject) return;
    setSaving(true);
    setMessage(null);
    try {
      await apiPut(`/data/av-lighting-projects/${currentProject.id}`, { data: pendingData });
      setProjects((prev) => prev.map((p) => (p.id === currentProject.id ? { ...p, data: pendingData } : p)));
      setMessage({ ok: true, text: "Saved." });
    } catch (e) {
      setMessage({ ok: false, text: "Error saving: " + e.message });
    }
    setSaving(false);
  };

  const handleToolChange = (toolKey, toolData) => {
    setPendingData((prev) => ({ ...prev, [toolKey]: toolData }));
  };

  return (
    <div>
      <div style={{ ...st.card, display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <span style={{ fontSize: 12, color: D.muted }}>Project:</span>
        <select value={currentProject?.id || ""} onChange={(e) => selectProject(e.target.value)} style={{ ...st.input, width: 220 }}>
          <option value="">— No project (unsaved) —</option>
          {projects.map((p) => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </select>
        <button style={st.btn()} onClick={createProject}>+ New Project</button>
        <button style={st.btn("primary")} onClick={saveProject} disabled={!currentProject || saving}>
          {saving ? "Saving…" : "💾 Save Project"}
        </button>
        {message && <span style={{ fontSize: 12, color: message.ok ? D.success : D.danger }}>{message.text}</span>}
      </div>

      <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap" }}>
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{ ...st.btn(t.id === tab ? "primary" : "default"), marginLeft: 0 }}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === "led" && <LedJobEstimate {...props} />}
      {tab === "load-schedule" && (
        <LoadSchedule
          key={currentProject?.id || "blank"}
          initialData={pendingData.loadSchedule}
          onChange={(data) => handleToolChange("loadSchedule", data)}
        />
      )}
      {tab === "zones-scenes" && (
        <ZonesScenes
          key={currentProject?.id || "blank"}
          loadScheduleData={pendingData.loadSchedule}
          initialData={pendingData.zonesScenes}
          onChange={(data) => handleToolChange("zonesScenes", data)}
        />
      )}
      {tab === "av-planner" && (
        <AVPlanner
          key={currentProject?.id || "blank"}
          initialData={pendingData.avPlanner}
          onChange={(data) => handleToolChange("avPlanner", data)}
        />
      )}
    </div>
  );
}
